<template>
	<div class="head">
		<!-- <div class="top">
			<ul>
				<template v-if="isLogin">
                    <li class="hyc">欢迎 {{userInfo.username}}</li>
                    <li class="entry" @click="goPage('/admin')">进入</li>
                </template>
                <template v-else>
                    <li @click="goPage('/apply')">注册</li>
                    <li @click="goPage('/login')">登录</li>
                </template>
				<template>
					<li @click="goPage(applyToJoinRoute)">用户登录</li>
				</template>
			</ul>
		</div> -->
		<div class="nav_menu">
			<div class="left">
				<!-- <img src="./../../../assets/images/logo.png" height="64" alt=""> -->
				<div style="width: 346px; height: 58px" @click="Jump">
					<img :src="siteLogo" height="64" alt="" style="width: 100%; height: 100%; object-fit: contain" />
				</div>
				<div class="logo_text" style="display: none">
					<p>国家应急安全标识注册管理公共服务平台</p>
					<p>中国安全生产科学研究院</p>
					<!-- <p>China Academy of Safety Science and Technology</p> -->
				</div>
			</div>
			<ul class="nav">
				<li v-for="(item, index) in menuList" :key="item.url + index" @click="goPage(item)" :class="{ active: selectUrl == item.urlPath }">
					{{ item.name }}
				</li>
				<!-- <li>新闻动态</li>
                <li>申请加入</li>
                <li>应用领域</li>
                <li>关于我们</li> -->
			</ul>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import { websiteInfo, topColumnList } from '@/api/admin';
export default {
	name: 'Head',
	data() {
		return {
			siteLogo: '',
			routerData: {
				首页: {
					url: '/home'
				},
				标识资讯: {
					url: '/news'
				},
				钢铁行业: {
					url: '/policy'
				},
				行业应用: {
					url: '/Industry'
				},
				// Industry
				// 行业应用: {
				// 	url: '/app-field'
				// },
				平台介绍: {
					url: '/about'
				}
			},
			menuList: [],
			applyToJoinRoute: {}, // 申请加入路由
			selectUrl: '/home', //当前选中菜单
			isLogin: false //是否登录
		};
	},
	watch: {
		// $route(to){
		//     this.selectUrl=to.path
		// },
		$route: {
			//监听的对象
			immediate: true,
			deep: true, //深度监听设置为 true
			handler: function (to) {
				let routeCache = to.path;
				if (to.path.indexOf('details') > -1) {
					this.selectUrl = localStorage.getItem('routeCache');
				} else {
					this.selectUrl = routeCache;
					localStorage.setItem('routeCache', routeCache);
				}
			}
		}
	},
	computed: {
		...mapState({
			userInfo(state) {
				state = state.user.userInfo;
				return state;
			},
			unitInfo(state) {
				state = state.user.unitInfo;
				return state;
			}
		})
	},
	created() {
		this.getWebsite();
		this.topColumnInfo();
	},
	mounted() {
		// this.selectUrl=this.$route.path
		if (Object.keys(this.userInfo).length > 0) {
			this.isLogin = true;
		}
	},
	methods: {
		getWebsite() {
			//获取站点设置
			websiteInfo({}).then((res) => {
				this.siteLogo = res.data.siteBanner;
			});
		},
		// 获取顶级栏目
		topColumnInfo() {
			topColumnList({}).then((res) => {
				// console.log(res.data, '获取顶级栏目');
				this.menuList = res.data.map((el) => {
					let routerData = this.routerData[el.name] || {};
					let row = {
						...el,
						urlPath: el.columnType == 1 ? routerData.url || '' : el.url
					};
					if (el.name == '申请加入') {
						for (let k in row) {
							this.$set(this.applyToJoinRoute, k, row[k]);
						}
					}
					return row;
				});
			});
		},
		goPage(row) {
			console.log(row, 'rowrow');
			let url = row.urlPath;
			if (url) {
				this.selectUrl = url;
				if (row.columnType == 1) {
					this.$router.push({
						path: url,
						query: {
							id: row.id,
							banner: row.banner
						}
					});
				} else {
					window.open(url);
				}
			}
		},
		Jump() {
			this.$router.push({ path: '/home' });
		}
	}
};
</script>
<style lang="scss" scoped>
.head {
	box-shadow: 0px 2px 4px 0px rgba(204, 204, 204, 0.5);
	.top {
		width: 100%;
		height: 48px;
		background: #fafafa;
		> ul {
			width: 1200px;
			height: 100%;
			margin: 0 auto;
			// border: 1px solid #0f0;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			li {
				font-size: 16px;
				padding: 0 22px;
				color: #4d4d4d;
				font-weight: 400;
				cursor: pointer;
			}
			// li:nth-child(1){
			//     border-right: 2px solid #999;;
			// }
			.hyc {
				color: #4d4d4d;
				cursor: auto;
			}
			.entry {
				color: #006300;
			}
		}
	}
	.nav_menu {
		height: 70px;
		width: 1200px;
		margin: 0 auto;
		// border: 1px solid #0f0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left {
			display: flex;
			align-items: center;
			.logo_text {
				margin-left: 20px;
				color: #006300;
				white-space: nowrap;

				p {
					line-height: 25px;
					white-space: nowrap;
				}
				p:nth-child(1) {
					font-size: 20px;
					// color: #1A1A1A;
					font-weight: 600;
					letter-spacing: 2px;
					white-space: nowrap;
				}
				p:nth-child(2) {
					font-size: 19px;
					letter-spacing: 2px;
				}
			}
		}
		.nav {
			display: flex;
			align-items: center;
			li {
				font-size: 17px;
				font-weight: 500;
				color: #4d4d4d;
				margin: 0 25px;
				cursor: pointer;
				padding: 8px 0;
			}
			li:hover {
				color: #047704; /* 鼠标悬浮时的颜色 */
			}
			.active {
				color: #047704;
				font-weight: bold;
				border-bottom: 2px solid #047704;
			}
		}
	}
}
</style>
